import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

import Fade from "react-reveal/Fade";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useStateContext } from "../../../../context/StateContext_KO";

const EnterShippingOption = (props) => {
  const [selected, setSelected] = useState("");
  const { getSubtotal } = useStateContext();

  useEffect(() => {
    if (getSubtotal() > 35) {
      setSelected("Free");
    } else {
      setSelected("Standard");
    }
  }, []);

  console.log(selected);
  console.log(props);
  let address =
    props.shippingAddress.firstname +
    " " +
    props.shippingAddress.lastname +
    " - " +
    props.shippingAddress.address +
    props.shippingAddress.apt +
    " " +
    props.shippingAddress.city +
    " " +
    props.shippingAddress.state +
    " " +
    props.shippingAddress.zipcode;

  const handleChange = (event) => {
    props.refreshComp();
    props.setShipping((old) => event.target.value);
    props.setShipingOption((old) => event.target.value);
    setSelected(event.target.value);
  };

  console.log(getSubtotal());

  return (
    <Box sx={{ pt: 7, px: 7, pb: 10 }}>
      <Fade delay={300}>
        <Box
          sx={{
            display: "flex",
            width: 1,
            borderBottom: "1px solid lightgray",
            paddingBottom: "10px",
          }}
        >
          <Box sx={{ pr: 4 }}>Email</Box>
          <Box>{props.email}</Box>
          <Box
            sx={{
              fontSize: "14px",
              color: "gray",
              marginLeft: "auto",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => props.goToFirstStep()}
          >
            Edit
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            width: 1,
            borderBottom: "1px solid lightgray",
            paddingBottom: "10px",
            paddingTop: "20px",
          }}
        >
          <Box sx={{ pr: 4 }}>Address</Box>
          <Box>{address}</Box>
          <Box
            sx={{
              fontSize: "14px",
              color: "gray",
              marginLeft: "auto",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => props.goToPreviousStep()}
          >
            Edit
          </Box>
        </Box>
        <Box sx={{ pt: 6 }}>
          <Box sx={{ pb: 2 }}>Select one of shipping options</Box>
          <Box>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                value={selected}
                onChange={handleChange}
              >
                {getSubtotal() > 35 ? (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel
                      value="Free"
                      control={<Radio />}
                      label="Free Shipping"
                    />
                    <Box sx={{ fontSize: "13px" }}>
                      Transit Time: 3-6 Business Days
                    </Box>
                  </Box>
                ) : null}
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FormControlLabel
                    value="Standard"
                    control={<Radio />}
                    label="Standard $5"
                  />
                  <Box sx={{ fontSize: "13px" }}>
                    Transit Time: 3-6 Business Days
                  </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FormControlLabel
                    value="Expedit"
                    control={<Radio />}
                    label="Expedit $10"
                  />
                  <Box sx={{ fontSize: "13px" }}>
                    Transit Time: 3-6 Business Days
                  </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FormControlLabel
                    value="Express"
                    control={<Radio />}
                    label="Express $20"
                  />
                  <Box sx={{ fontSize: "13px" }}>
                    Transit Time: 3-6 Business Days
                  </Box>
                </Box>
              </RadioGroup>
            </FormControl>

            <button
              className="custom_btn"
              onClick={() => props.goToNextStep()}
              style={{ marginTop: "20px" }}
            >
              Go To Next Step
            </button>
          </Box>
          <Box sx={{ pt: 3, fontSize: "13px" }}>
            Note: Items in your order may ship separately. Transit time is the
            time from item(s) leaving our fulfillment center to delivery to you.
          </Box>
        </Box>
      </Fade>
    </Box>
  );
};

export default EnterShippingOption;
